import { Info, Mic } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { DropdownMenuGroup, DropdownMenuItem } from 'components/dropdown/dropdown';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import { useAudioDevice } from 'providers/AudioDeviceProvider';

export function WorkstationMenuItems() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();
  const showAudioSettings = useAudioDevice().mode === 'active';

  return (
    <DropdownMenuGroup>
      {showAudioSettings && (
        <DropdownMenuItem
          onClick={() => {
            trackEvent(ANALYTICS_EVENTS.TITLEBAR_MENU_ITEM_CLICKED, { title: 'audioSettings' });
            void navigate('/audio-settings');
          }}
        >
          <Mic /> {t('audio.settings.title')}
        </DropdownMenuItem>
      )}
      <DropdownMenuItem
        onClick={() => {
          trackEvent(ANALYTICS_EVENTS.TITLEBAR_MENU_ITEM_CLICKED, { title: 'systemInformation' });
          void navigate('/systemInformation');
        }}
      >
        <Info /> {t('systemInformation.title')}
      </DropdownMenuItem>
    </DropdownMenuGroup>
  );
}
